import { Stack } from '@material-ui/core';
import React from 'react';
import { FORM_TYPE, FormType } from 'src/constants';
import { Action5RequestTargetDataGrid } from './Action5RequestTargetDataGrid';
import { RequestTargetDataGrid } from './RequestTargetDataGrid';

export interface Props {
  formType?: FormType;
}

const EnqueteStatusListTab: React.FC<Props> = React.memo((props) => {
  const { formType } = props;

  const render = () => {
    switch (formType) {
      case FORM_TYPE.COMPLIA:
        return <Action5RequestTargetDataGrid />;
      default:
        return <RequestTargetDataGrid />;
    }
  };
  return (
    <Stack direction="column" spacing={2}>
      {render()}
    </Stack>
  );
});

export default EnqueteStatusListTab;
